import * as React from 'react'
const SvgPinBuildin = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="26"
    height="34"
    viewBox="0 0 44.479 57.358"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      fill="#010101"
      d="m46 76.234 1.225-1.271c.857-.892 21.017-17.063 21.017-33.845 0-12.264-9.978-22.242-22.241-22.242-12.262 0-22.412 9.98-22.238 22.242.24 17.004 20.156 32.953 21.014 33.844z"
      style={{
        fill: '#262626',
        fillOpacity: 1,
      }}
      transform="translate(-23.763 -18.876)"
    />
    <path
      d="M38.445 27.194a2.52 2.52 0 0 0-2.518 2.519v21.83a2.52 2.52 0 0 0 2.518 2.519h5.038v-4.198a2.52 2.52 0 0 1 5.038 0v4.198h5.038a2.52 2.52 0 0 0 2.518-2.519v-21.83a2.52 2.52 0 0 0-2.518-2.519zm.84 12.594c0-.461.378-.84.84-.84h1.679c.462 0 .84.379.84.84v1.68c0 .461-.378.84-.84.84h-1.68a.842.842 0 0 1-.839-.84zm5.877-.84h1.68c.461 0 .84.379.84.84v1.68c0 .461-.379.84-.84.84h-1.68a.842.842 0 0 1-.84-.84v-1.68c0-.461.379-.84.84-.84m4.198.84c0-.461.378-.84.84-.84h1.68c.461 0 .839.379.839.84v1.68c0 .461-.378.84-.84.84H50.2a.842.842 0 0 1-.84-.84zm-9.235-7.556h1.679c.462 0 .84.378.84.84v1.679c0 .461-.378.84-.84.84h-1.68a.842.842 0 0 1-.839-.84v-1.68c0-.461.378-.84.84-.84m4.198.84c0-.462.378-.84.84-.84h1.679c.461 0 .84.378.84.84v1.679c0 .461-.379.84-.84.84h-1.68a.842.842 0 0 1-.84-.84zm5.877-.84h1.68c.461 0 .839.378.839.84v1.679c0 .461-.378.84-.84.84H50.2a.842.842 0 0 1-.84-.84v-1.68c0-.461.378-.84.84-.84"
      style={{
        strokeWidth: 0.052476,
        fill: props.fill,
      }}
      transform="translate(-23.763 -18.876)"
    />
  </svg>
)
export default SvgPinBuildin
